export class Photo {
    public title!: string
    public url!: string

    constructor() { }
}

export class GalleryWidget {
    public title!: string
    public photos: Photo[] = [];

    constructor() { }
}
